import { useState } from "react";
import { ModalVideo } from "../../components/ModalVideo/Index";
import Title from "../../components/Title";
import imageProfessional from "../../image/poster-professional.png";
import imageAppointHours from "../../image/poster-appointHours.png";
import imageClient from "../../image/poster-client.png";
import imageProject from "../../image/poster-project.png";
import imageSetting from "../../image/poster-setting.png";
import imageOnboarding from "../../image/Onboarding.jpg";

export const Tutorial = () => {
  const VIDEO_PROFESSIONAL = "../../../../onboarding/professionalVideo.mp4";
  const VIDEO_APPOINT_HOURS = "../../../../onboarding/appointHoursVideo.mp4";
  const VIDEO_CLIENT = "../../../../onboarding/clientVideo.mp4";
  const VIDEO_PROJECT = "../../../../onboarding/projectVideo.mp4";
  const VIDEO_SETTING = "../../../../onboarding/settingVideo.mp4";
  const VIDEO_ONBOARDING = "../../../../onboarding/Onboarding.mp4";

  return (
    <>
      <div className="container">
        <Title title="Tutoriais" />
        <div className="box-form p-4 text-1.6rem text-textPrimary justify-around">
          <div className="flex justify-around w-full">
            <CardTutorial imageUrl={imageOnboarding} title="Boas Vindas" url={VIDEO_ONBOARDING} />
            <CardTutorial imageUrl={imageSetting} title="Configurações iniciais" url={VIDEO_SETTING} />
          </div>
          <div className="flex justify-around w-full">
            <CardTutorial imageUrl={imageProfessional} title="Cadastro de Profissional" url={VIDEO_PROFESSIONAL} />
            <CardTutorial imageUrl={imageClient} title="Cadastro de Cliente" url={VIDEO_CLIENT} />
          </div>
          <div className="flex justify-around w-full">
            <CardTutorial imageUrl={imageProject} title="Cadastro de Projeto" url={VIDEO_PROJECT} />
            <CardTutorial imageUrl={imageAppointHours} title="Apontamento de Horas" url={VIDEO_APPOINT_HOURS} />
          </div>
        </div>
      </div>
    </>
  );
};

const CardTutorial = ({ imageUrl, title, url }: { imageUrl: string; title: string; url: string }) => {
  const [modalVideo, setModalVideo] = useState(false);

  return (
    <>
      {modalVideo && (
        <ModalVideo modalVideo={modalVideo} setModalVideo={setModalVideo} videoUrl={url} posterUrl={imageUrl} title={`Tutorial - ${title}`} />
      )}
      <div
        className="flex items-center h-40 rounded-xl shadow-xl bg-gray-100 p-4 transition duration-300 hover:ease-in filter hover:brightness-90 cursor-pointer"
        style={{ width: "32%" }}
        onClick={() => setModalVideo(true)}
      >
        <div className="w-1/2">
          <img src={imageUrl} className="h-36 rounded-xl" />
        </div>
        <div className="flex flex-col items-center justify-around w-1/2 h-full">
          <span>{title}</span>
          <span className="text-primary">Veja já o tutorial</span>
        </div>
      </div>
    </>
  );
};
